"use client"

import styled from "@emotion/styled"
import { FC, useRef } from "react"
import FloatingChatButtonSimple from "../common/FloatingChatButtonSimple"

const SHOW_AI_CHAT_BUTTON =
  process.env.NEXT_PUBLIC_SHOW_AI_CHAT_BUTTON === "true"

const Styled = {
  Main: styled.main`
    flex-grow: 1;
    height: 100%;
    ${(p) => p.theme.breakpoints.up("md")} {
      display: flex;
      flex-direction: column;
    }

    :focus {
      outline: 0;
    }
  `,
}

const Layout: FC<any> = ({ children }) => {
  const mainRef = useRef<HTMLDivElement>(null)
  return (
    <>
      <Styled.Main id="mainContent" tabIndex={-1} ref={mainRef}>
        {children}
      </Styled.Main>

      {/* Floating Chat Button */}
      {SHOW_AI_CHAT_BUTTON && (
        <FloatingChatButtonSimple
          onChatOpen={() => console.log("Chat opened")}
        />
      )}
      {/* <Footer /> */}
    </>
  )
}

export default Layout
